/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PayType } from './PayType';
import {
    PayTypeFromJSON,
    PayTypeFromJSONTyped,
    PayTypeToJSON,
    PayTypeToJSONTyped,
} from './PayType';

/**
 * 
 * @export
 * @interface CreatePayTypeResponse
 */
export interface CreatePayTypeResponse {
    /**
     * 
     * @type {PayType}
     * @memberof CreatePayTypeResponse
     */
    data: PayType;
}

/**
 * Check if a given object implements the CreatePayTypeResponse interface.
 */
export function instanceOfCreatePayTypeResponse(value: object): value is CreatePayTypeResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreatePayTypeResponseFromJSON(json: any): CreatePayTypeResponse {
    return CreatePayTypeResponseFromJSONTyped(json, false);
}

export function CreatePayTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePayTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PayTypeFromJSON(json['data']),
    };
}

  export function CreatePayTypeResponseToJSON(json: any): CreatePayTypeResponse {
      return CreatePayTypeResponseToJSONTyped(json, false);
  }

  export function CreatePayTypeResponseToJSONTyped(value?: CreatePayTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PayTypeToJSON(value['data']),
    };
}

